/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "2980d680ce2ca95d613c7660e8e13f702e2469f6";
